/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class DocumentApi extends BaseApi {
  endPoint: string = '/api/admin/documents';
}
